export function ActiveSco() {

    let activeScoId = null;

    // revealing public api
    return {

        isAvailable: () =>  {
            return activeScoId !== null;
        },

        set: ( scoId ) => {
            activeScoId = scoId;
        },

        get: () =>  {
            return activeScoId;
        },

        clear: () =>  {
            activeScoId = null;
        }
    };
}
